// extracted by mini-css-extract-plugin
export default {"header":"styles_header__+P8I2"};